import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import DayName from './DayName';
import TableField from './TableField';
import { ReserveInfoModalData } from '@/components/modals';

import './styles.scss';

export interface ReserveReportTableProps {
  reports?: ReportDayEntity[];
  mealTypes?: ReserveMealEntity[];
  onItemClick?: (data: ReserveInfoModalData) => any;
}

export function ReserveReportDesktop({
  reports = [],
  mealTypes = [],
  onItemClick = undefined
}: ReserveReportTableProps) {

  const [t] = useTranslation(['common']);
  const classname = 'flex justify-center';

  const columns = [{
    title: <div className={classname}>{t('common:labels.date')}</div>,
    dataIndex: 'date',
    key: 'date',
    width: undefined,
  }];

  (columns[0] as any).fixed = 'left';

  for (const meal of mealTypes) {
    columns.push({
      key: meal.name,
      title: <div className={classname}>{meal.name}</div>,
      dataIndex: String(meal.id),
      width: undefined
    });
  }

  const textNoReservation = t('reserve:labels.no-reservation');
  const textReserved = t('reserve:labels.reserved');
  const textConsumed = t('reserve:labels.consumed');

  const dataSource = reports.map((report, key) => {


    const entry = { key, date: <DayName day={report} /> } as any;
    // console.log("report",report);

    for (const meal of mealTypes) {
      const filteredMealTypes = (report?.mealTypes ?? []).filter(m => (
        m?.reserve != null ||
        m?.teammateReserve != null
      ));
      const dailysales = (report?.dailySales ?? []).filter(d => (
        d?.mealTypeId == meal.id
      ))


      if (!filteredMealTypes && !dailysales) {
        entry[meal.id] = <div className={classname}>{textNoReservation}</div>;
      }
      else {
        const foods = filteredMealTypes.filter(food => (
          food?.reserve?.mealTypeId === meal.id ||
          food?.teammateReserve?.mealTypeId === meal.id
        ));

        // console.log(foods);


        let text: string;
        let isAllConsumed = false;
        if (foods.length === 0 && dailysales.length === 0) {
          text = textNoReservation;
        }
        else {
          const selfConsumedCount = foods.filter(f => f?.reserve?.consumed).length || 0;
          const teammateConsumedCount = foods.filter(f => f?.teammateReserve?.consumed).length || 0;
          const dailySaleConsumedCount = dailysales.filter(f => f?.consumed).length || 0;


          isAllConsumed = (selfConsumedCount + teammateConsumedCount + dailySaleConsumedCount) === foods.length + dailysales.length;
          let count = 0;

          // Add counts from regular reserves
          for (const food of foods) {
            count += food?.reserve?.selectedCount || 0;
            count += food?.teammateReserve?.selectedCount || 0;
          }

          // Add counts from daily sales that match the meal type
          const matchingDailySales = report?.dailySales?.filter(sale =>
            sale.mealTypeId === meal.id
          ) || [];

          for (const sale of matchingDailySales) {
            count += sale.selectedCount || 0;
          }

          // Check if there are only teammate reserves
          const hasOnlyTeammateReserves = foods.every(food =>
            !food?.reserve && food?.teammateReserve
          );

          // Check if user has any actual teammate reserves
          const hasTeammateReserves = foods.some(food => food?.teammateReserve);

          text = isAllConsumed ?
            textConsumed + ` (${t('common:labels.count-of', { value: count })})` :
            hasOnlyTeammateReserves && hasTeammateReserves ?
              'همگروهی' + ` (${t('common:labels.count-of', { value: count })})` :
              textReserved + ` (${t('common:labels.count-of', { value: count })})`;
        }

        const checkActive =
         ( !!filteredMealTypes?.some(food => (
            food?.reserve?.mealTypeId === meal.id ||
            food?.teammateReserve?.mealTypeId === meal.id
          )) || report?.dailySales?.some(sale =>
            sale.mealTypeId === meal.id
          ) )


        entry[meal.id] = (
          <TableField
            key={meal.id}
            text={text}
            isAllConsumed={isAllConsumed}
            isEmptyDay={!filteredMealTypes}
            isActive={checkActive}
            onClick={onItemClick.bind({}, {
              mealTypes: foods, meal, report,
              startServeTime: foods[0]?.startServeTime || foods[0]?.teammateReserve?.startServeTime,
              endServeTime: foods[0]?.endServeTime || foods[0]?.teammateReserve?.endServeTime,
              demonstrationDescription: foods[0]?.demonstrationDescription || foods[0]?.teammateReserve?.demonstrationDescription,
            })}
          />
        );
      }
    }
    return entry;
  });

  return (
    <div className="app-reserve-report-table">
      <Table
        bordered={false}
        className="app-table"
        showHeader={true}
        columns={columns}
        pagination={false}
        scroll={{ x: '100%' }}
        dataSource={dataSource}
      />
    </div>
  );
}

export default ReserveReportDesktop;
